import "./PdtDetail.css";

import { useParams, Link } from "react-router-dom";

import {getJsonPath, getBkendUrl} from "../../consts";

import { imgs, getRandomImg, getRandomInArray, getUploadFileUrl } from "../../consts";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios_with_token from "../../axios_with_token";

import { useData } from "../../consts";

import { AddToCart } from "../../app2/ShoppingCart/ShoppingCart";

// // [] bare for test
// export function _PdtDetail(props){
//     const {cart, setCart} = useData();
//     return <div>
//         <form className="input-group p-3 flex-grow-0  d-inline-flex"
                
//                 onSubmit={evt=>{
//                     evt.stopPropagation();
//                     evt.preventDefault();
//                 }}
//             >
//                 <span className="input-group-text">quantity</span>
//                 <input
//                     type="text"
//                     className="form-control"
//                     // placeholder="Recipient's username"
//                     aria-label="quantity"
//                     style={{"flex":"0", "width":"5em", "maxWidth":"5em"}}
//                     // {...register(qtyName)}
//                 />
//                 <button className="btn btn-outline-secondary"
//                     type="button"
//                     // onClick={evt=>{setValue(qtyName, Math.max((getValues()[qtyName]||0)-1,0))}}
//                 >-</button>
//                 <button className="btn btn-outline-secondary"
//                     type="button"
//                     // onClick={evt=>{setValue(qtyName, (getValues()[qtyName]||0)+1)}}
//                 >+</button>
//                 <button className="btn btn-outline-secondary"
//                     type="button"

//                     onClick={evt=>{
//                         const pdt={__id: window._ww_tools.uuidv4()};
//                         const newCart = {...cart};
//                         const qty = 3;
//                         newCart[pdt.__id] = newCart[pdt.__id] || {pdt: pdt, qty:0};
//                         newCart[pdt.__id].qty += qty;

//                         setCart(newCart);
//                     }}
//                 >add to cart</button>
//             </form>
//     </div>
// }

const jsonPath = getJsonPath();
const bkendUrl = getBkendUrl();

export default function PdtDetail({}){
    const params = useParams();
    // const [pdt, setPdt] = useState({});
    const [currentPdt, setCurrentPdt] = useState();

    const {cart, setCart} = useData();

    const pdt = currentPdt || {};

    let pdtImgs = [];
    try{
      pdtImgs = JSON.parse(pdt.images || "[]");
    }catch(err){
      pdtImgs = [];
    }

    // useEffect(_=>{
    //     if(!params.pdtCatid)return;

    //     const _currentPdtCat = (pdtCats||[]).find(obj=>parseInt(obj.__id)==parseInt(params.pdtCatid));
    //     // if(_currentPdtCat)setCurrentPdtCat(_currentPdtCat);
  
    // }, [params.pdtCatid, pdtCats])

    useEffect(_=>{
        if(!params.pdtId)return;

        axios_with_token.post(
            `${bkendUrl}/jwt/gettblrcd/${jsonPath}/pdts/${params.pdtId}`
        ).then(res=>{
            if(!res)return;
            // setPdt(res.data.data.rcd);
            setCurrentPdt(res.data.data.rcd);
        });
    }, [params.pdtId])
    
    return <div className="container">

        <div className="row mb-3">
            <h1>{pdt.name}</h1>
            <span>sn: {pdt.sn}</span>
        </div>

        <div className="row">
            <div className="col-md-4">
            <div className="card">
                {/* getRandomInArray)( */}
                <img src={getUploadFileUrl((pdtImgs[0]||{}).url)} className="card-img-top" alt="..." />
                <div className="card-body">
                    <h5 className="card-title">Card title</h5>
                    <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                </div>
                <ul className="list-group list-group-flush">
                    <li className="list-group-item">An item</li>
                    <li className="list-group-item">A second item</li>
                    <li className="list-group-item">A third item</li>
                </ul>
                <div className="card-body">
                    <a href="#" className="card-link">Card link</a>
                    <a href="#" className="card-link">Another link</a>
                </div>
                </div>

            </div>
            <div className="col-md-8">

                <div className="accordion" id="accordionExample">
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            Accordion Item #1
                        </button>
                        </h2>
                        <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                        </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTwo">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            Accordion Item #2
                        </button>
                        </h2>
                        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                        </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingThree">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            Accordion Item #3
                        </button>
                        </h2>
                        <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                        </div>
                        </div>
                    </div>
                </div>

                <AddToCart 
                    pdt={pdt}
                    actionButton={"addToCart"}
                    qty={0}
                />

            </div>
        </div>
    </div>
};